import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ChangeDetectorRef, ViewRef, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location, NgClass } from '@angular/common';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../../store/state/app.state';
import { GetCMSDataService, QuoteDataCaptureService, ModalScroll, UtilService, CURRENT_ENVIROMENT, MEDICAL_UW_HO_URL, SERVICE_END_POINT, AnalyticsService, FormValidationsService} from '../../shared';
import { RefNo } from '../../model/ngrx/reference-number.model';
import * as UserDataConfig from '../config/user-data.config';
import { SyncService } from 'src/app/pages/medical-underwriting/services/sync.service';
import { AlertModal } from 'src/app/model/alert';
import { ApplicationDataCaptureService } from 'src/app/shared/services/api-services/application-datacapture.service';
import { MEDICAL_UW_URL } from 'src/app/shared/constants/medical-uw-url.constants';
import { SaveReturnModel, InvalidCtlNameObj } from 'src/app/pages/medical-underwriting/model/mcUserJourney.model';
import { SaveComponent } from '../save/save.component';
import { ProductChoice } from 'src/app/model/ngrx';
import { UnderWritingData, AnnuitantMedicalConditions } from 'src/app/pages/medical-underwriting/model';
import { UtilityServiceForMedicalService } from 'src/app/pages/medical-underwriting/services/utility-service';
import { MedicalCondQuestionSet } from 'src/app/pages/medical-underwriting/medical-underwrting.constants';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { ModalComponent } from '../modal/modal.component';

@Component({
    selector: 'app-content-top-nav',
    templateUrl: './content-top-nav.component.html',
    styleUrls: ['./content-top-nav.component.scss'],
    imports: [NgClass, SaveComponent, ModalComponent]
})
export class ContentTopNavComponent implements OnInit {

  @Input() visibleBackNav;
  @Input() enableFwdNav;
  @Input() enableBackNav;
  @Input() saverAndReturnObj: SaveReturnModel;
  @Input() closeBtnEnabled: boolean;
  @Input() visibleSaveProgress = true;
  // tslint:disable-next-line:no-output-on-prefix
  @Output() backClickHandler: EventEmitter<any> = new EventEmitter<any>();
  // tslint:disable-next-line:no-output-on-prefix
  @Output() closeClickHandler: EventEmitter<boolean> = new EventEmitter<boolean>();
  referenceNumberStore: Observable<RefNo[]>;
  referenceNumber: RefNo;
  @Input() parentElement: ElementRef;
  @Input() cdRefParent: ChangeDetectorRef;
  @Input()  parentFormToJustToClear: UntypedFormGroup;
  @Input() emitInvalidEvtFlag: boolean;
  @ViewChild('savecomp', { static: false }) savecomp: SaveComponent ;
  @Input()  parentFormToValidate: UntypedFormGroup; // this is to check if any invalid data is present in the form
  enableQuote = false;
  abc = false;
  contentData;
  partyId: string;
  isVisible: boolean;
  screenName;
  private subscriptn: Subscription;
  public displayAlert = false;
  protected serverDetail;
  public breadcrumbDetails = UserDataConfig.BreadcrumbConfig.data;


  arrBreadcrumb: any;
  breadcrumbs: any;
  isDataPresent: boolean;
  isLocked: boolean;
  loginDetail: any;
  public lockedAlertModalConfig: AlertModal;

  public CMSData;
  postProductsChoiceStore: Observable<ProductChoice[]>;
  postProductChoice: ProductChoice;
  lifeStyleFromStoreObsSubscription: Subscription;
  lifeStylePayloadFromStoreObj: UnderWritingData;
  private totalMedCount: number;
  private medCondListFromStore: AnnuitantMedicalConditions[];

  constructor(private messageService: GetCMSDataService, public router: Router, private location: Location,
              private route: ActivatedRoute,
              private syncService: SyncService,
              private quoteDatacaptureService: QuoteDataCaptureService,
              private store: Store<AppState>, private btnFocusOnModalClose: ModalScroll,
              private utilService: UtilService, private applicationDatacaptureService: ApplicationDataCaptureService,
              private analyticsService: AnalyticsService,
              private utilityServiceForMedicalService: UtilityServiceForMedicalService) {
    this.contentData = this.route.snapshot.data.contentData;
    this.serverDetail = UserDataConfig.BreadcrumbConfig.authServer;
    this.referenceNumberStore = this.store.select(STORE_VAL.ref_no);
    this.referenceNumberStore.subscribe((val) => {
      if (val.length > 0) {
        this.referenceNumber = val[0];
      }
    });
    this.store.select(STORE_VAL.loggedin_detail).subscribe(res => {
      if (res.length > 0) {
        this.loginDetail = res[0];
        this.partyId = res[0].customer.partyId ? res[0].customer.partyId : -1;
      }
    });

    this.postProductsChoiceStore = this.store.select(STORE_VAL.product_choice);
    this.postProductsChoiceStore.subscribe(res => {
      if (res.length > 0) {
        this.postProductChoice = res[0];
      }
    });

    this.lifeStyleFromStoreObsSubscription = this.store.select(STORE_VAL.lifestyle).subscribe(res => {
      if (res.length > 0) {
        this.lifeStylePayloadFromStoreObj = res[0];
      }
    });

  }
  setAlertatSavecomponent(){
    this.savecomp.displayAlert = true;
    this.savecomp.saveAlertWithoutLogin = true;
  }

  ngOnInit() {
    
    this.CMSContentMapper();
    if ((this.router.url.indexOf('/home/get-your-online-quote') > -1)) {
      this.enableQuote = !this.loginDetail ? true : false;
    } else if (this.router.url === '/home/registration' || this.router.url === ('/home/post-registration/Success')
     || this.router.url === ('/home/post-registration/Failure')
    || this.router.url === ('/home/post-registration/Unavailable')) {
      this.abc = true;

    }
    this.lockedAlertModalConfig = this.contentData['modalConfigLocked']; // CMS 

    this.isUWdataPresent();
  }

  ngOndestroy() {
    if(this.subscriptn) {
      this.subscriptn.unsubscribe();
    }
  }

  scrollInvalidForm() {
    if (this.parentElement) {
      setTimeout(() => {
        const invalidElements = this.parentElement.nativeElement.querySelectorAll('.form-validation-error');
        if (invalidElements.length > 0) {
          invalidElements[0].scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
        }
      }, 0);
    }
  }

  goBack = (userForm: UntypedFormGroup) => {
    this.analyticsService.eventTrack({type: 'ButtonClick', name: 'Back', pageID: this.getCurrentScreenURL()});
    this.analyticsService.orderTrack({ internalReferenceDCJ: this.referenceNumber?.quoteReferenceNumber, applicationReferenceDCJ:this.referenceNumber?.applicationRefNumber});
    FormValidationsService.clearFormErrors(this.parentFormToJustToClear);
    FormValidationsService.clearFormErrors(this.parentFormToValidate);
    if (this.cdRefParent && !(this.cdRefParent as ViewRef).destroyed) {
			this.cdRefParent.detectChanges();
		}
    let invalidDataObj: InvalidCtlNameObj = FormValidationsService.isInvalidDataFoundInForm(this.parentFormToValidate);
    if (invalidDataObj && invalidDataObj.invalidDataPresent) {
      if (this.emitInvalidEvtFlag) {
        this.utilService.emitInvalidMessageEvt(invalidDataObj);
      }
      else {
        FormValidationsService.validateAllFormForOneCtl(this.parentFormToValidate, invalidDataObj.ctlName);
        this.scrollInvalidForm();
      }
      return;
    }
    // tslint:disable-next-line: max-line-length
    if (this.router.url === '/apply/your-pension-savings' || this.router.url === '/home/update-my-details' || this.router.url === '/home/registration'){
      this.analyticsService.eventTrack({type: 'ButtonClick', name: 'Back', pageID: this.getCurrentScreenURL()});
      this.backClickHandler.emit();
      return;
    }
    
    const isHoview = this.router.url.indexOf('ho-underwriting') > -1 ? true : false;
    // tslint:disable-next-line: max-line-length
    if (this.router.url === '/home/you-will-need' || this.router.url.substr(1, 5) === 'apply') {
      this.gotoBack(userForm);
    } else {
      this.utilService.isQuoteLocked(this.referenceNumber ? this.referenceNumber?.quoteReferenceNumber : null).subscribe(
        res => {
          if (res && !this.router.url.includes('ho-underwriting')) {
            this.isLocked = true;
          } else {
            this.isLocked = false;
            if (this.enableBackNav) {
              // tslint:disable-next-line: max-line-length
              if (this.router.url === MEDICAL_UW_URL.annuitant.medicalConditions || this.router.url === MEDICAL_UW_HO_URL.annuitant.medicalConditions) {
                if (isHoview) {
                  this.router.navigate([MEDICAL_UW_HO_URL.annuitant.lifestyle]);
                } else {
                  this.router.navigate([MEDICAL_UW_URL.annuitant.lifestyle]);
                }
              } else
                if (this.router.url === MEDICAL_UW_URL.annuitant.ADL || this.router.url === MEDICAL_UW_HO_URL.annuitant.ADL) {
                  this.backClickHandler.emit();
                  if (isHoview) {
                    this.router.navigate([MEDICAL_UW_HO_URL.annuitant.medicalConditions]);
                  } else {
                  this.router.navigate([MEDICAL_UW_URL.annuitant.medicalConditions]);
                  }
                } else
                    // tslint:disable-next-line: max-line-length
                    if (this.router.url === MEDICAL_UW_URL.annuitant.doctorDetails || this.router.url === MEDICAL_UW_HO_URL.annuitant.doctorDetails) {
                      if (this.isDataPresent) {
                        if (isHoview) {
                          this.router.navigate([MEDICAL_UW_HO_URL.annuitant.ADL]);
                        } else {
                          this.router.navigate([MEDICAL_UW_URL.annuitant.ADL]);
                        }
                      } else {
                        if (isHoview) {
                          this.router.navigate([MEDICAL_UW_HO_URL.annuitant.medicalConditions]);
                        } else {
                        this.router.navigate([MEDICAL_UW_URL.annuitant.medicalConditions]);
                        }
                      }
                    } else
                    if (this.router.url === '/home/your-dependant') {
                        this.backClickHandler.emit();
                        this.router.navigate([MEDICAL_UW_URL.annuitant.doctorDetails]);
                    }else if
                    // tslint:disable-next-line: max-line-length
                     ((this.router.url === MEDICAL_UW_URL.annuitant.diabetes) || (this.router.url === MEDICAL_UW_HO_URL.annuitant.diabetes)) {
                      if (isHoview) {
                        this.router.navigate([MEDICAL_UW_HO_URL.annuitant.AMC]);
                      } else {
                      this.router.navigate([MEDICAL_UW_URL.annuitant.AMC]);
                      }
                    }
                    else if
                    // tslint:disable-next-line: max-line-length
                     ((this.router.url === MEDICAL_UW_URL.dependant.dependantDiabetes) || (this.router.url === MEDICAL_UW_HO_URL.dependant.dependantDiabetes)) {
                      if (isHoview) {
                        this.router.navigate([MEDICAL_UW_HO_URL.dependant.dependantAMC]);
                      } else {
                      this.router.navigate([MEDICAL_UW_URL.dependant.dependantAMC]);
                      }
                    }
                     else if
                      // tslint:disable-next-line: max-line-length
                       (this.router.url.includes(MEDICAL_UW_URL.annuitant.DMC) || this.router.url.includes(MEDICAL_UW_HO_URL.annuitant.DMC)) {
                        this.backClickHandler.emit();
                        if (isHoview) {
                          this.router.navigate([MEDICAL_UW_HO_URL.annuitant.diabetes]);
                        } else {
                        this.router.navigate([MEDICAL_UW_URL.annuitant.diabetes]);
                        }
                      } else if
                        // tslint:disable-next-line: max-line-length
                         (this.router.url === MEDICAL_UW_URL.annuitant.medicalConditions || this.router.url ===  MEDICAL_UW_HO_URL.annuitant.medicalConditions) {
                          if (isHoview) {
                            this.router.navigate([MEDICAL_UW_HO_URL.annuitant.AMC]);
                          } else {
                          this.router.navigate([MEDICAL_UW_URL.annuitant.AMC]);
                          }
                        } else
                          if (this.router.url === MEDICAL_UW_URL.annuitant.AMC || this.router.url === MEDICAL_UW_HO_URL.annuitant.AMC) {
                            if (isHoview) {
                              this.router.navigate([MEDICAL_UW_HO_URL.annuitant.medicalConditions]);
                            } else {
                            this.router.navigate([MEDICAL_UW_URL.annuitant.medicalConditions]);
                            }
                          } else
                          if (this.router.url === MEDICAL_UW_HO_URL.dependant.dependantLifestyle || this.router.url === MEDICAL_UW_URL.dependant.dependantLifestyle) {
                            if (isHoview) {
                              this.router.navigate([MEDICAL_UW_HO_URL.annuitant.doctorDetails]);
                            } else {
                              this.backClickHandler.emit();
                            }
                            
                          } else if
                          // tslint:disable-next-line: max-line-length
                           (this.router.url === MEDICAL_UW_URL.dependant.dependantMedicalConditions || this.router.url === MEDICAL_UW_HO_URL.dependant.dependantMedicalConditions) {
                            if (isHoview) {
                              this.router.navigate([MEDICAL_UW_HO_URL.dependant.dependantLifestyle]);
                            } else {
                            this.router.navigate([MEDICAL_UW_URL.dependant.dependantLifestyle]);
                            }
                          } else
                            // tslint:disable-next-line: max-line-length
                            if (this.router.url === MEDICAL_UW_URL.dependant.dependantADL || this.router.url === MEDICAL_UW_HO_URL.dependant.dependantADL) {
                              this.backClickHandler.emit();
                              if (isHoview) {
                                this.router.navigate([MEDICAL_UW_HO_URL.dependant.dependantMedicalConditions]);
                              } else {
                              this.router.navigate([MEDICAL_UW_URL.dependant.dependantMedicalConditions]);
                              }
                            } else
                                // tslint:disable-next-line: max-line-length
                                if (this.router.url === MEDICAL_UW_URL.dependant.dependantDoctorDetails || this.router.url === MEDICAL_UW_HO_URL.dependant.dependantDoctorDetails) {
                                  if (this.isDataPresent) {
                                    if (isHoview) {
                                      this.router.navigate([MEDICAL_UW_HO_URL.dependant.dependantADL]);
                                    } else {
                                      this.router.navigate([MEDICAL_UW_URL.dependant.dependantADL]);
                                    }
                                  } else {
                                    if (isHoview) {
                                      this.router.navigate([MEDICAL_UW_HO_URL.dependant.dependantMedicalConditions]);
                                    } else {
                                    this.router.navigate([MEDICAL_UW_URL.dependant.dependantMedicalConditions]);
                                    }
                                  }
                                } else
                                  // tslint:disable-next-line: max-line-length
                                  if (this.router.url.includes(MEDICAL_UW_URL.dependant.dependantDMC) || this.router.url.includes(MEDICAL_UW_HO_URL.dependant.dependantDMC)) {
                                    this.backClickHandler.emit();
                                    if (isHoview) {
                                      this.router.navigate([MEDICAL_UW_HO_URL.dependant.dependantDiabetes]);
                                    } else {
                                    this.router.navigate([MEDICAL_UW_URL.dependant.dependantDiabetes]);
                                    }
                                  } else
                                    // tslint:disable-next-line: max-line-length
                                    if (this.router.url === MEDICAL_UW_URL.dependant.dependantDiabetes || this.router.url === MEDICAL_UW_HO_URL.dependant.dependantDiabetes) {
                                      if (isHoview) {
                                        this.router.navigate([MEDICAL_UW_HO_URL.dependant.dependantAMC]);
                                      } else {
                                        this.router.navigate([MEDICAL_UW_URL.dependant.dependantAMC]);
                                      }
                                    } else
                                      // tslint:disable-next-line: max-line-length
                                      if (this.router.url === MEDICAL_UW_URL.dependant.dependantAMC || this.router.url === MEDICAL_UW_HO_URL.dependant.dependantAMC) {
                                        if (isHoview) {
                                          this.router.navigate([MEDICAL_UW_HO_URL.dependant.dependantMedicalConditions]);
                                        } else {
                                        this.router.navigate([MEDICAL_UW_URL.dependant.dependantMedicalConditions]);
                                        }
                                      } else {
                            this.gotoBack(userForm);
                          }
            }
          }
        });
    }
  }

  gotoBack(userForm: any) {
   

    let NextBreadCrumb: string;
    this.btnFocusOnModalClose.handleModalScrollFlag({ scrollModalFlag: false, btnFocus: false });
    this.messageService.sendUserData({ data: userForm ? userForm.value : null, index: 0 });
    if (this.router.url.substr(1, 5) === 'apply') {
      this.applicationDatacaptureService.postApplicationDataCapture(false);
    } else {
      this.quoteDatacaptureService.postQuoteDataCapture(false);
    }
    const val = this.router.url;
    const currentBreadCrumb = this.breadcrumbDetails.values.find(b => b.path === val);

    if (val.indexOf('ho-underwriting') > -1) {
      this.arrBreadcrumb = this.breadcrumbDetails.values.filter(b => b.type === currentBreadCrumb.type);
      const indexOfCurrentBreadCrumb = this.arrBreadcrumb.findIndex(a => a.id === currentBreadCrumb.id);
      NextBreadCrumb = this.arrBreadcrumb[indexOfCurrentBreadCrumb - 1].path;

    } else {
      this.arrBreadcrumb = this.breadcrumbDetails.values.filter(b => b.type === currentBreadCrumb.type).filter(c => c.enable);
      const indexOfCurrentBreadCrumb = this.arrBreadcrumb.findIndex(a => a.id === currentBreadCrumb.id);
      if (indexOfCurrentBreadCrumb === 0 && currentBreadCrumb.type === 'main') {
        NextBreadCrumb = this.breadcrumbDetails.values.find(b => b.id === 1).path;
      } else if (val === '/quote/please-confirm-your-details') {
        NextBreadCrumb = this.breadcrumbDetails.values.find(b => b.id === 22).path;
    } else if (val === '/apply/clear-to-apply') {

        NextBreadCrumb = this.breadcrumbDetails.values.find(b => b.id === 25).path;
      } else if (val === '/apply/user-login-required'){
        NextBreadCrumb = this.breadcrumbDetails.values.find(b => b.id === 24).path;
      }else {
        NextBreadCrumb = this.arrBreadcrumb[indexOfCurrentBreadCrumb - 1].path;
      }
    }

    this.router.navigate([NextBreadCrumb]);
    this.backClickHandler.emit();
  }
  retriveQuote() {
  this.analyticsService.eventTrack({type: 'ButtonClick', name: 'Retrieve quote', pageID: this.getCurrentScreenURL()});
  this.afterSaveSuccessfully();
  }
  

   afterSaveSuccessfully() {
    if (CURRENT_ENVIROMENT.environment !== 'localEnvironment') {
      // tslint:disable-next-line: max-line-length
      let serverName = '';
      if (document.location.href.toString().toUpperCase().includes('LOCALHOST')) {
        serverName = 'localhost';
      } else {
        if ( document.location.href.indexOf('lgnet') > -1) {
          // tslint:disable-next-line: max-line-length
          serverName = document.location.href.substring(document.location.href.indexOf('//') + 2, document.location.href.indexOf('lgnet') - 1);
        } else {
          // tslint:disable-next-line: max-line-length
          serverName = document.location.href.substring(document.location.href.indexOf('//') + 2, document.location.href.indexOf('landg') - 1);

        }
      }
      const configServername = this.serverDetail.find(s => s.serverName === serverName);
      // tslint:disable-next-line: max-line-length
      if (this.referenceNumber) {
        this.quoteDatacaptureService.GetRefnumberEncrypted(this.referenceNumber?.quoteReferenceNumber).subscribe(ref => {
          // tslint:disable-next-line: max-line-length
          this.quoteDatacaptureService.loginRedirect(`${configServername.secAuthUrl}/SAuthGateWeb/login.html?domain=dcj&entryPoint=${configServername.entryPointUrl}%2Feap%2Frequest%2Fdcj%2FcustomerLogin?quoteRefNo=${ref.quoteReference}`);
        });
      } else {
        // tslint:disable-next-line:max-line-length
        this.quoteDatacaptureService.loginRedirect(`${configServername.secAuthUrl}/SAuthGateWeb/login.html?domain=dcj&entryPoint=${configServername.entryPointUrl}%2Feap%2Frequest%2Fdcj%2FcustomerLogin`);
      }
    } else {

      this.quoteDatacaptureService.postLoginCapture('', '', '').subscribe(res => {
        if (res.showWarning === 'Y') {
          this.displayAlert = true;
        } else {
          const redirectUrl = this.getScreenName(res.currentScreen);
          this.router.navigate([redirectUrl]);
        }
      }, error => this.displayAlert = false);

    }

  }
public getScreenName(currentscreen): string {
  const breadcrumbDetails = UserDataConfig.BreadcrumbConfig.data.values;
  return breadcrumbDetails.find(br => br.screenName === currentscreen).path;
}

 close() {
    this.analyticsService.eventTrack({type: 'ButtonClick', name: 'Close', pageID: this.getCurrentScreenURL()});
    this.closeClickHandler.emit(true);
  }
  closeLockedModal() {
    this.isLocked = false;
  }
 /** Code block for CMS */
CMSContentMapper() {
  const URL = SERVICE_END_POINT.higherEnvironment.CMS_ToGetAQuoteYouWillNeed;
  this.utilService.getCMSData(URL).subscribe(res => {
    this.CMSData = res.commonBlock;
  /** This method should only be called once CMSData != null */
    if (this.CMSData) {
      /** In the line below we are over-writing the contentData object values with CMSData object values */
      this.contentData.contentTopNavigationBar.back = this.CMSData.string_BackCTALabel;
      this.contentData.contentTopNavigationBar.retrieveQuote = this.CMSData.string_RetrieveQuoteLabel;
    }
});
}
/** End of code block for CMS */

isUWdataPresent(){
  if(this.postProductChoice && this.postProductChoice.selectedProduct && this.postProductChoice.selectedProduct === 'C') {

    if (this.utilityServiceForMedicalService.currentUWScreenName === 'annuitant') {
      this.getTotalMedCount(this.lifeStylePayloadFromStoreObj.annuitantMedicalConditions);
    } else
    if (this.utilityServiceForMedicalService.currentUWScreenName === 'dependant') {
      this.getTotalMedCount(this.lifeStylePayloadFromStoreObj.dependentMedicalConditions);
    }
   
    if(this.totalMedCount > 0) {
      this.isDataPresent = true;
    } else {
      this.isDataPresent = false;
    }
  }
}

getTotalMedCount(medCondList: AnnuitantMedicalConditions[]) {
  this.medCondListFromStore = [];
  medCondList.forEach(element => {
    if ((element.questionSetName === MedicalCondQuestionSet.lifestyle) ||
      element.questionSetName === MedicalCondQuestionSet.adl) {

    }
    else {
      this.medCondListFromStore.push(element);
    }
  });
  if (this.medCondListFromStore.length > 0) {
    this.totalMedCount = this.medCondListFromStore.length;
  }
  else {
    this.totalMedCount = 0;
  }
}

/** For web tracking */
getCurrentScreenURL() {
  this.screenName = this.utilService.getScreenNameFromURL(this.router.url);

  return this.screenName;
}

}
